import React from 'react';

import { makeStyles } from '@material-ui/core/styles';

import { ReactComponent as WarningIcon } from '../../../assets/images/warning_icon_orange.svg';
import { t } from '../../../providers';

const useStyles = makeStyles((theme) => ({
    errorHandlerSection: {
        background: '#FEF3C7',
        margin: '10px 0px 25px 0px',
        boxShadow: '0px 3px 3px -2px rgba(0, 0, 0, 0.2), 0px 3px 4px rgba(0, 0, 0, 0.14), 0px 1px 8px rgba(0, 0, 0, 0.12)',
        minHeight: '96px',
        width: '320px',
        borderRadius: '4px',
        overflow: 'auto',
    },
    warningIcon: {
        marginTop: '23.33px',
        marginLeft: '24.06px',
        marginBottom: '58.5px',
    },
    errorTitle: {
        fontSize: '0.875rem',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '20px',
        letterSpacing: '-0.20000000298023224px',
        textAlign: 'left',
        color: '#3D1B0A',
        marginTop: '16px',
        marginBottom: '8px',
    },
    errorSubtitle: {
        color: '#5D5D5D',
        fontSize: '0.75rem',
        fontStyle: 'normal',
        fontWeight: '400',
        lineHeight: '16px',
        letterSpacing: '0em',
        textAlign: 'left',
        margin: '0px',
        paddingBottom: '16px',
    },
    titlesSection: {
        float: 'left',
        width: '176px',
        marginLeft: '16.06px',
    },
    errorAction: {
        float: 'left',
        paddingTop: '64px',
        paddingRight: '8px',
    },
}));

const ErrorHandler = ({ title, subtitle, action }) => {
    const classes = useStyles();

    return (
        <div className={classes.errorHandlerSection}>
            <div style={{ float: 'left' }}>
                <WarningIcon className={classes.warningIcon} aria-hidden="true" focusable="false" />
            </div>
            <div className={classes.titlesSection}>
                <h3 className={classes.errorTitle}>{t(title)}</h3>
                <h4 className={classes.errorSubtitle}>{t(subtitle)}</h4>
            </div>
            <div className={classes.errorAction}>{action}</div>
        </div>
    );
};

export default ErrorHandler;
